import { createStore } from 'owa-satcheljs';
import type OwaLayoutStore from './schema/owaLayoutStore';

const owaLayoutStore: OwaLayoutStore = {
    browserHeightBucket: null,
    browserWidthBucket: null,
    mainAppMinHeight: null,
    areDisplayAdsEnabled: false,
    isMainAppHeightOverflow: false,
};

export const getStore: () => OwaLayoutStore = createStore<OwaLayoutStore>(
    'OwaLayout',
    owaLayoutStore
);
